module.exports = __webpack_public_path__ + "img/icon-modify.d32558a5.svg";